export default __webpack_public_path__ + "static/media/GR00028-disciple_medal_4.215d9260.svg";